@if (formGroup()) {
<div class="batch-panel">
    <form class="content-form" [formGroup]="formGroup()!" (ngSubmit)="onSubmit()">
        <div class="header">
            <ul class="tabs">
                @for (tab of tabs; track tab.caption) {
                <li class="tab" [hidden]="tab.hidden"><a class="tab-link" (click)="onClick(tab)"
                        [ngClass]="{'active': tabSelected == tab}">{{tab.caption}}</a></li>
                }
            </ul>
        </div>
        <div class="body">
            @if (prototypeModel) {
            <div class="row content" [hidden]="tabSelected != tabBatch">
                @for (tag of contentModel?.tags; track tag.value) {
                <app-expansion [status]="model().custome[tag.key]" [meta]="{title: tag.key}">
                    @for (field of tag.value; track field.meta.id) {
                    <app-content-field [formGroup]="formGroup()!" [field]="field" [node]="$any(node())"></app-content-field>
                    }
                </app-expansion>
                }
            </div>
            }
            @if (prototypeModel) {
            <div class="row publish" [hidden]="tabSelected != tabPublish">
                <app-publish [formGroup]="formGroup()!" [node]="$any(node())"></app-publish>
            </div>
            }
        </div>
        @if (prototypeModel) {
        <div class="footer">
            <div class="row">
                <button type="submit" class="button button-big" [disabled]="disabled">
                    <mat-icon class="regular-icon">save</mat-icon>
                </button>
            </div>
        </div>
        }
    </form>
</div>
}
